import { render, staticRenderFns } from "./SipServer.vue?vue&type=template&id=4bd4df8a&"
import script from "./SipServer.vue?vue&type=script&lang=js&"
export * from "./SipServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports